import Vue from 'vue'

import clonedeep from 'lodash.clonedeep'

import apiDocuments from '@src/api/documents';
import apiUser from '@src/api/user';

import SEARCH_TABLE_CONFIG from './table_config'

const INITIAL_SORTING = [
  {
    field: 'type',
    label: 'Индекс',
    asc: true,
    active: false
  },
  {
    field: 'number',
    label: 'Номер',
    asc: true,
    active: false
  },
  {
    field: 'title',
    label: 'Наименование',
    asc: true,
    active: false
  },
  {
    field: 'approvalDate',
    label: 'Дата утверждения',
    asc: false,
    active: false
  },
  {
    field: 'startDate',
    label: 'Дата вступления в силу',
    asc: false,
    active: false
  }
]

const SHARE_CONFIG = [
  {
    queryKey: 'availableOnly',
    searchKey: 'searchAvailableOnly',
    type: 'number'
  },
  {
    queryKey: 'checklists',
    searchKey: 'searchChecklists',
    type: 'array',
    options: {
      apiFunction: 'getChecklistsByIds',
      addIds: true
    }
  },
  {
    queryKey: 'classifiers',
    searchKey: 'searchClassifiers',
    type: 'array',
    options: {
      apiFunction: 'getClassifiersByIds',
      addIds: true
    }
  },
  {
    queryKey: 'countTotal',
    searchKey: 'searchCountTotal',
    type: 'number'
  },
  {
    queryKey: 'limit',
    searchKey: 'searchItemsLimit',
    type: 'number'
  },
  {
    queryKey: 'offset',
    searchKey: 'searchOffset',
    type: 'number'
  },
  {
    queryKey: 'organizations',
    searchKey: 'searchOrganizations',
    type: 'array',
    options: {
      apiFunction: 'getOrganizationsByIds',
      addIds: true
    }
  },
  {
    queryKey: 'designers',
    searchKey: 'searchDesigners',
    type: 'array',
    options: {
      apiFunction: 'getDesignersByIds',
      addIds: true
    }
  },
  {
    queryKey: 'sort',
    searchKey: 'searchSort',
    type: 'sort'
  },
  {
    queryKey: 'statuses',
    searchKey: 'searchStatuses',
    type: 'array',
    options: {
      apiFunction: 'getStatuses'
    }
  },
  {
    queryKey: 'title',
    searchKey: ['searchQuery','text'],
    type: 'string'
  },
  {
    queryKey: 'groupByDb',   // ??????????????????????????
    searchKey: ['searchQuery','searchBy'],
    type: 'number'
  },
  {
    queryKey: 'types',
    searchKey: 'searchTypes',
    type: 'array',
    options: {
      apiFunction: 'getTypesByIds',
      addIds: true
    }
  },
  {
    queryKey: 'dates',
    searchKey: 'searchDates',
    type: 'array'
  }
]

// Создает параметры запроса из параметров state
function createQuery(ctx) {
  let obj = {};

  obj.text = ctx.searchQuery.text;
  obj.searchBy = ctx.searchQuery.searchBy;
  obj.availableOnly = ctx.searchAvailableOnly;
  obj.countTotal = ctx.searchCountTotal;
  obj.limit = ctx.searchItemsLimit;
  obj.offset = ctx.searchOffset;
  obj.modifiedFrom = ctx.searchDateModifiedFrom;
  obj.modifiedTo = ctx.searchDateModifiedTo;
  obj.enteredFrom = ctx.searchDateEnteredFrom;
  obj.enteredTo = ctx.searchDateEnteredTo;
  obj.canceledFrom = ctx.searchDateCanceledFrom;
  obj.canceledTo = ctx.searchDateCanceledTo;
  obj.approvedFrom = ctx.searchApprovedFrom;
  obj.approvedTo = ctx.searchApprovedTo;
  obj.addedFrom = ctx.searchAddedFrom;
  obj.addedTo = ctx.searchAddedTo;

  // Свойства ниже это не просто значение id, а объекты
  obj.types = ctx.searchTypes.map(i => i.id);
  obj.classifiers = ctx.searchClassifiers.map(i => i.id);
  obj.checklists = ctx.searchChecklists.map(i => i.id);
  obj.organizations = ctx.searchOrganizations.map(i => i.id);
  obj.designers = ctx.searchDesigners.map(i => i.id);
  obj.statuses = ctx.searchStatuses.map(i => i.id);

  obj.sort = ctx.searchSort
    .filter(i => i.active)
    .map(i => `${i.asc ? '' : '-'}${i.field}`)
    .join(',');

  if (obj.sort === '') delete obj.sort;

  return obj;
}

// Создает объект для записи в историю из параметров state
function setFullQuery(ctx, shareObj = {}) {
  let obj = {};
  let cond

  cond = shareObj.searchQuery && shareObj.searchQuery.text
  obj.text = cond? shareObj.searchQuery.text: ctx.searchQuery.text;
  cond = shareObj.searchQuery && shareObj.searchQuery.searchBy
  obj.searchBy = cond? shareObj.searchQuery.searchBy: ctx.searchQuery.searchBy;
  
  obj.availableOnly = shareObj.searchAvailableOnly? shareObj.searchAvailableOnly: ctx.searchAvailableOnly;
  obj.countTotal = shareObj.searchCountTotal? shareObj.searchCountTotal: ctx.searchCountTotal;
  obj.limit = shareObj.searchItemsLimit? shareObj.searchItemsLimit: ctx.searchItemsLimit;
  obj.offset = shareObj.searchOffset? shareObj.searchOffset: ctx.searchOffset;
  obj.searchDateModifiedFrom = shareObj.searchDateModifiedFrom? shareObj.searchDateModifiedFrom: 
    ctx.searchDateModifiedFrom;
  obj.searchDateModifiedTo = shareObj.searchDateModifiedTo? shareObj.searchDateModifiedTo: 
    ctx.searchDateModifiedTo;
  obj.searchDateEnteredFrom = shareObj.searchDateEnteredFrom? shareObj.searchDateEnteredFrom: 
    ctx.searchDateEnteredFrom;
  obj.searchDateEnteredTo = shareObj.searchDateEnteredTo? shareObj.searchDateEnteredTo: 
    ctx.searchDateEnteredTo;
  obj.searchDateCanceledFrom = shareObj.searchDateCanceledFrom? shareObj.searchDateCanceledFrom: 
    ctx.searchDateCanceledFrom;
  obj.searchDateCanceledTo = shareObj.searchDateCanceledTo? shareObj.searchDateCanceledTo: 
    ctx.searchDateCanceledTo;
  obj.searchApprovedFrom = shareObj.searchApprovedFrom? shareObj.searchApprovedFrom: 
    ctx.searchApprovedFrom;
  obj.searchApprovedTo = shareObj.searchApprovedTo? shareObj.searchApprovedTo: 
    ctx.searchApprovedTo;
  obj.searchAddedIsMonth = shareObj.searchAddedIsMonth? shareObj.searchAddedIsMonth: 
    ctx.searchAddedIsMonth;
  obj.searchAddedFrom = shareObj.searchAddedFrom? shareObj.searchAddedFrom: 
    ctx.searchAddedFrom;
  obj.searchAddedTo = shareObj.searchAddedTo? shareObj.searchAddedTo: 
    ctx.searchAddedTo;
  obj.searchAddedFromDay = shareObj.searchAddedFromDay? shareObj.searchAddedFromDay: 
    ctx.searchAddedFromDay;
  obj.searchAddedToDay = shareObj.searchAddedToDay? shareObj.searchAddedToDay: 
    ctx.searchAddedToDay;
  obj.searchAddedMonthFrom = shareObj.searchAddedMonthFrom? shareObj.searchAddedMonthFrom: 
    ctx.searchAddedMonthFrom;
  obj.searchAddedMonthTo = shareObj.searchAddedMonthTo? shareObj.searchAddedMonthTo: 
    ctx.searchAddedMonthTo;
  obj.searchAddedFilter = shareObj.searchAddedFilter? shareObj.searchAddedFilter: 
    ctx.searchAddedFilter;

  // Свойства ниже это не просто значение id или еще какое-то, а массив объектов
  obj.types = shareObj.searchTypes
    ? shareObj.searchTypes.map(i => Object.assign({}, i))
    : ctx.searchTypes.map(i => Object.assign({}, i));
  obj.classifiers = shareObj.searchClassifiers
    ? shareObj.searchClassifiers.map(i => Object.assign({}, i))
    : ctx.searchClassifiers.map(i => Object.assign({}, i));
  obj.checklists = shareObj.searchChecklists
    ? shareObj.searchChecklists.map(i => Object.assign({}, i))
    : ctx.searchChecklists.map(i => Object.assign({}, i));
  obj.organizations = shareObj.searchOrganizations
    ? shareObj.searchOrganizations.map(i => Object.assign({}, i))
    : ctx.searchOrganizations.map(i => Object.assign({}, i));
  obj.designers = shareObj.searchDesigners
    ? shareObj.searchDesigners.map(i => Object.assign({}, i))
    : ctx.searchDesigners.map(i => Object.assign({}, i));
  obj.statuses = shareObj.searchStatuses
    ? shareObj.searchStatuses.map(i => Object.assign({}, i))
    : ctx.searchStatuses.map(i => Object.assign({}, i));
  obj.sort = shareObj.searchSort
    ? shareObj.searchSort.map(i => Object.assign({}, i))
    : ctx.searchSort.map(i => Object.assign({}, i));
  obj.dates = shareObj.searchDates
    ? shareObj.searchDates.map(i => Object.assign({}, i))
    : ctx.searchDates.map(i => Object.assign({}, i));

  return obj;
}

export default {
  state: {
    // Параметры сессии поиска 'search' для поисковой или 'classifiers'/'checklists'
    sessionStatus: '',
    // Данные для отображения найденных перечней и состояния
    // поисковой строки для перечней
    foundChecklists: [],
    checklistsSearchString: '',
    // Справочники для формирования запросов постоянные в рамках текущей
    // сессии пользователя (классификаторы, организации )
    classifiersList: [],
    // Параметры для формирования запроса
    searchQuery: {
      text: '',
      searchBy: 'designation'
    },
    searchAvailableOnly: 0,
    searchItemsLimit: 20,
    searchOffset: 0,
    searchDateModifiedFrom: "",
    searchDateModifiedTo: "",
    searchDateEnteredFrom: "",
    searchDateEnteredTo: "",
    searchDateCanceledFrom: "",
    searchDateCanceledTo: "",
    searchApprovedFrom: "",
    searchApprovedTo: "",
    searchAddedIsMonth: "",
    searchAddedFrom: "",
    searchAddedTo: "",
    searchAddedFromDay: "",
    searchAddedToDay: "",
    searchAddedMonthFrom: "",
    searchAddedMonthTo: "",
    searchAddedFilter: "", 
    searchClassifiers: [],
    searchChecklists: [],
    searchSort: INITIAL_SORTING.map(i => Object.assign({}, i)),
    searchStatuses: [],
    searchDates: [],
    searchTypes: [],
    searchOrganizations: [],
    searchDesigners: [],
    searchCountTotal: 1,

    modeView: 'list',
    sidebarStatus: '', //'filter',

    result: {
      /** @type {Array<ApiDocumentSearchCardDef>} */
      items: [],
      total: 0
    },
    loading: false,
    loadingError: null,
    history: [],

    openInWindow: false,
    searchTableConfig: []
  },

  getters: {
    searchSessionStatus: state => state.sessionStatus,
    sidebarStatus: state => state.sidebarStatus,
    modeView: state => state.modeView,

    searchHistory: state => JSON.parse(JSON.stringify(state.history)),
    searchQuery: state => Object.assign({}, state.searchQuery),
    searchQueryText: state => state.searchQuery.text,
    searchTypes: state => JSON.parse(JSON.stringify(state.searchTypes)),
    searchOrganizations: state => JSON.parse(JSON.stringify(state.searchOrganizations)),
    searchDesigners: state => JSON.parse(JSON.stringify(state.searchDesigners)),
    searchAvailableOnly: state => state.searchAvailableOnly,
    searchDateModifiedFrom: state => state.searchDateModifiedFrom,
    searchDateModifiedTo: state => state.searchDateModifiedTo,
    searchDateEnteredFrom: state => state.searchDateEnteredFrom,
    searchDateEnteredTo: state => state.searchDateEnteredTo,
    searchDateCanceledFrom: state => state.searchDateCanceledFrom,
    searchDateCanceledTo: state => state.searchDateCanceledTo,
    searchApprovedFrom: state => state.searchApprovedFrom,
    searchApprovedTo: state => state.searchApprovedTo,
    searchAddedIsMonth: state => state.searchAddedIsMonth,
    searchAddedFrom: state => state.searchAddedFrom,
    searchAddedTo: state => state.searchAddedTo,
    searchAddedFromDay: state => state.searchAddedFromDay,
    searchAddedToDay: state => state.searchAddedToDay,
    searchAddedMonthFrom: state => state.searchAddedMonthFrom,
    searchAddedMonthTo: state => state.searchAddedMonthTo,
    searchStatuses: state => state.searchStatuses.map(i => i),
    searchDates: state => state.searchDates.map(i => i),
    searchSort: state => state.searchSort.map(i => Object.assign({}, i)),

    searchOffset: state => state.searchOffset? state.searchOffset: 0,
    searchLimit: state => state.searchItemsLimit,

    classifiersList: state => JSON.parse(JSON.stringify(state.classifiersList)),
    selectedClassifiers: state =>
      JSON.parse(JSON.stringify(state.searchClassifiers)),
    foundedChecklists: state =>
      JSON.parse(JSON.stringify(state.foundChecklists)),
    checklistsSearchString: state => state.checklistsSearchString,
    selectedChecklists: state =>
      state.searchChecklists.map(item => {
        return {
          id: item.id,
          title: item.title
        };
      }),

    filtersState: state => {
      let organizations = state.searchOrganizations.map(i => i.name);
      let datesApproved = (state.searchApprovedFrom ? "с " + 
      state.searchApprovedFrom.substr(8, 2) + "." + 
      state.searchApprovedFrom.substr(5, 2) + "." + 
      state.searchApprovedFrom.substr(0, 4) : "") +
      (state.searchApprovedFrom && state.searchApprovedTo ? " " : "") +
      (state.searchApprovedTo ? "по " + 
      state.searchApprovedTo.substr(8, 2) + "." + 
      state.searchApprovedTo.substr(5, 2) + "." + 
      state.searchApprovedTo.substr(0, 4) : "");
      if (datesApproved)
        organizations.push(datesApproved);
      return {
        availableOnly: state.searchAvailableOnly,
        classifiers: state.searchClassifiers.map(i => i.title),
        checklists: state.searchChecklists.map(i => i.title),
        statuses: state.searchStatuses.map(i => i.name),
        types: state.searchTypes.map(i => i.name),
        organizations: organizations,
        designers: state.searchDesigners.map(i => i.name),
        dates: state.searchDates.map(i => i.name + ' ' + i.value),
        addedInBase: state.searchAddedFilter
      };
    },
    searchResults: state => JSON.parse(JSON.stringify(state.result)),
    searchHistory: state => state.history
      .map(item => clonedeep(item))
      .reverse(),
    isLoading: state => state.loading,

    getOpenInWindow: state => state.openInWindow,
    searchTableConfig: state => state.searchTableConfig.map( i => typeof(i)==='object'? Object.assign({}, i): i),
    activeTableConfigItems: state => state.searchTableConfig.filter( i => i.active).length,
    queryAsString: state => {
      if (
        !state.searchQuery.text &&
        !state.searchClassifiers.length &&
        !state.searchChecklists.length
      ) return ''
        
      let obj = apiDocuments.prepareSearchQuery(createQuery(state))

      return Object.keys(obj).map(key => `${key}=${obj[key]}`).join('&')
    }
  },

  actions: {
    setModeView({commit}, mode) {
      commit('SET_MODE_VIEW', mode)
    },
    setCurrentDeviceSettings({ commit }) {
      let config = localStorage.getItem('sTableConfig')

      if( config === null ) {
        config = clonedeep(SEARCH_TABLE_CONFIG)
        localStorage.setItem('sTableConfig', JSON.stringify(config))
      } else {
        config = JSON.parse(config) 
      }
      commit('SET_CURRENT_DEVICE_SETTINGS', config);
    },
    resetSearchResultsTableSettings({ dispatch }) {
      localStorage.removeItem('sTableConfig')
      dispatch('setCurrentDeviceSettings') 
    },
    setNewColsWidth({ state, commit }, obj) {
      commit('SET_NEW_TABLE_COLUMNS_WIDTH', obj);
      localStorage.setItem('sTableConfig', JSON.stringify(state.searchTableConfig))
    },
    changeTableConfigProp({ state, commit }, {name, prop, mode}) {
      commit('SET_NEW_TABLE_CONFIG_PROP', {name, prop, mode});
      localStorage.setItem('sTableConfig', JSON.stringify(state.searchTableConfig))
    },
    setNewColsOrder({ state, commit }, obj) {
      commit('SET_NEW_TABLE_COLUMNS_ORDER', obj);
      localStorage.setItem('sTableConfig', JSON.stringify(state.searchTableConfig))
    },
    loadSearchHistory({ commit }) {
      const history = localStorage.getItem('searchHistory');

      if (history) {
        commit('SET_SEARCH_HISTORY', history);
      }
    },
    loadRequestFromHistory({ commit, dispatch }, query) {
      commit('UPDATE_SEARCH_REQUEST_FROM_HISTORY', query);
      commit('UPDATE_SESSION_STATUS', 'search');
      dispatch('getSearchResults');
    },

    // В случае, если список классификаторов пуст загружает этот список.
    async getClassifiersList({ state, commit }) {
      if (state.classifiersList.length) return;
      try {
        const list = await apiDocuments.getClassifiers();

        commit('SET_CLASSIFIERS_LIST', list);
      } catch (err) {
        console.log('Error when get classifiers list: ', err);
      }
    },

    async getClassifierFolders({ state, commit }, classifierId) {
      const ind = state.classifiersList.findIndex(
        item => item.id === classifierId
      );

      if (state.classifiersList[ind].folders) return;
      try {
        const folders = await apiDocuments.getClassifierFolders(classifierId);

        commit('SET_CLASSIFIER_FOLDERS', {
          position: ind,
          folders: folders
        });
      } catch (err) {
        console.log('Error when get classifier folders: ', err);
      }
    },

    // Обновляет хранимые параметры последнего запроса текстового поиска.
    setTextQueryParams({ state, commit, dispatch }, obj) {
      let isItialSessionStatus = state.sessionStatus

      if (state.sessionStatus !== 'search') {
        commit('UPDATE_SESSION_STATUS', 'search');
      }
      // Обнуление страницы при изменении запроса, чтобы не выпасть из области видимости
      commit('UPDATE_QUERY_PARAMETER', {
        parameter: 'searchOffset',
        value: 0
      })
      commit('SET_TEXT_QUERY_PARAMS', obj);
      dispatch('checkAllFiltersAreEmpty');

      if (isItialSessionStatus) dispatch('getSearchResults');
    },

    // Загружает результаты поиска, соответствующие текущим поисковым параметрам.
    async getSearchResults({ state, commit, dispatch }) {
      if (state.loading) commit('CANCEL_LOADING'); // Убрать loader еслии он активен
      commit('SET_SEARCH_RESULTS', { items: [], total: 0 });
      if (
        !state.searchQuery.text &&
        !state.searchClassifiers.length &&
        !state.searchChecklists.length
      )
        return;
      const newQuery = createQuery(state);

      commit('SET_IS_LOADING');
      try {
        const results = await apiDocuments.findDocuments(newQuery);

        commit('SET_SEARCH_RESULTS', results);
        commit('CANCEL_LOADING');
        if (newQuery.text && results.total) {
          commit('UPDATE_SEARCH_HISTORY', {
            query: setFullQuery(state),
            created: Date.now(),
            total: +results.total
          });
        }
      } catch (err) {
        commit('CANCEL_LOADING');
        commit('SET_SEARCH_ERROR', err);
        console.error('Error on search: ', err);
      }
    },

    // Получение списка перечней, соответствующих текущему поисковому запросу (для
    // поисковой сессии) или текущему состоянию инпута (для информационной сессии перечни)
    // Если параметр searchStr отсутствует (т.е. undefined), то поиск производится
    // по документам по значениям прочих фильтров
    async getChecklisits({ state, commit }, searchStr) {
      let foundChecklists = [];

      if (searchStr !== undefined) {
        // Если запрос не изменялся, то все значения остаются неизменными
        if (searchStr === state.checklistsSearchString) return;
        if (searchStr) {
          try {
            foundChecklists = await apiDocuments.getChecklistsByTitle(
              searchStr
            );
            commit('UPDATE_CHECKLISTS_SEARCH_STRING', searchStr);
          } catch (err) {
            console.error('Error on get checklists by title: ', err);
          }
        }
      } else if (state.sessionStatus === 'search') {
        try {
          foundChecklists = await apiDocuments.getChecklistsByDocuments(
            createQuery(state),
            500
          );
        } catch (err) {
          console.error('Error on get checklists for current filters: ', err);
        }
      }
      commit('UPDATE_FOUND_CHECKLISTS_DATA', foundChecklists);
    },

    // Обработка нажатия кнопки "ПЕРЕЧНИ" в header
    workoutSessionSidebarForChecklists({ state, dispatch, commit }) {
      if (state.sidebarStatus === 'checklists') {
        if (state.sessionStatus === 'checklists') {
          dispatch('closeRequestsSession', 'checklists');
        } else {
          if (!state.sessionStatus)
            commit('UPDATE_SESSION_STATUS', 'checklists');
        }
      } else {
        if (state.sessionStatus) {
          if (state.sessionStatus === 'classifiers') {
            if (state.searchClassifiers.length === 0) {
              commit('RESET_FILTERS');
              commit('UPDATE_SESSION_STATUS', 'checklists');
            } else {
              commit('UPDATE_SESSION_STATUS', 'search');
              dispatch('getChecklisits');
            }
          }
        } else {
          commit('UPDATE_SESSION_STATUS', 'checklists');
        }
      }
    },
    // Обработка нажатия кнопки "КЛАССИФИКАТОРЫ" в header
    workoutSessionSidebarForClassifiers({ state, dispatch, commit }) {
      if (state.sidebarStatus === 'classifiers') {
        if (state.sessionStatus === 'classifiers') {
          dispatch('closeRequestsSession', 'classifiers');
        } else {
          if (!state.sessionStatus)
            commit('UPDATE_SESSION_STATUS', 'classifiers');
        }
      } else {
        if (state.sessionStatus) {
          if (state.sessionStatus === 'checklists') {
            if (state.searchChecklists.length === 0) {
              commit('UPDATE_SESSION_STATUS', 'classifiers');
            } else {
              commit('UPDATE_SESSION_STATUS', 'search');
            }
          }
        } else {
          commit('UPDATE_SESSION_STATUS', 'classifiers');
        }
      }
    },
    // Обработка нажатия кнопки "ФИЛЬТР" в header
    workoutSessionSidebarForFilter({ state, dispatch, commit }) {
      if (state.sidebarStatus === 'filter') {
        // TODO: Look more properly AND may be remove
        if (state.sessionStatus !== 'search') {
          if (state.sessionStatus) {
            dispatch('closeRequestsSession', state.sessionStatus);
          }
          commit('UPDATE_SESSION_STATUS', 'search');
        }
      } else {
        if (state.sessionStatus !== 'search') {
          commit('UPDATE_SESSION_STATUS', 'search');
        }
      }
    },
    setSidebarStatus({ state, dispatch, commit }, sidebarMode) {
      switch (sidebarMode) {
        case 'checklists':
          dispatch('workoutSessionSidebarForChecklists');
          break;
        case 'classifiers':
          dispatch('workoutSessionSidebarForClassifiers');
          break;
        case 'filter':
          dispatch('workoutSessionSidebarForFilter');
          break;
      }
      // Обработка изменения состояния сайдбара в интерфейсе
      if (sidebarMode) {
        if (state.sidebarStatus === sidebarMode) sidebarMode = '';
      }
      commit('SET_SIDEBAR_STATUS', sidebarMode);
    },

    closeRequestsSession({ commit }, sessionName) {
      commit('UPDATE_SESSION_STATUS', '');
      commit('SET_SEARCH_RESULTS', { items: [], total: 0 });
      switch (sessionName) {
        case 'checklists':
          commit('UPDATE_CHECKLISTS_REQUEST', {
            mode: 'clean'
          });
          break;
        case 'classifiers':
          commit('UPDATE_CLASSIFIERS_REQUEST', {
            mode: 'clean'
          });
          break;
        case 'search':
          // TODO: Work out search session is closed
          break;
        default:
          console.error('Unknown request session name');
      }
    },
    changeChecklistsQuery({ state, dispatch, commit }, obj) {
      // Обнуление страницы при изменении запроса, чтобы не выпасть из области видимости
      commit('UPDATE_QUERY_PARAMETER', {
        parameter: 'searchOffset',
        value: 0
      })
      commit('UPDATE_CHECKLISTS_REQUEST', obj);
      if (!state.sessionStatus) commit('UPDATE_SESSION_STATUS', 'search');

      // Если все фильтры окажутся сюрошенными, то поисковая сессия завершится автоматически
      dispatch('checkAllFiltersAreEmpty');
      if (state.sessionStatus) {
        dispatch('getSearchResults');
      } else {
        commit('SET_SEARCH_RESULTS', { items: [], total: 0 });
      }
    },

    // Добавление/удаление классификатора из выбранных
    // obj: {selected: <boolean>, classifier: <объект классификатора>}
    changeClassifiersQuery({ state, dispatch, commit }, obj) {
      // Обнуление страницы при изменении запроса, чтобы не выпасть из области видимости
      commit('UPDATE_QUERY_PARAMETER', {
        parameter: 'searchOffset',
        value: 0
      })
      commit('UPDATE_CLASSIFIERS_REQUEST', {
        mode: obj.selected ? 'remove' : 'add',
        value: {
          id: obj.classifier.id,
          title: obj.classifier.name
        }
      });
      if (!state.sessionStatus) commit('UPDATE_SESSION_STATUS', 'search');

      // Если все фильтры окажутся сюрошенными, то поисковая сессия завершится автоматически
      dispatch('checkAllFiltersAreEmpty');
      if (state.sessionStatus) {
        dispatch('getSearchResults');
      } else {
        commit('SET_SEARCH_RESULTS', { items: [], total: 0 });
      }
    },

    // Изменение параметров поискового запроса с обновлением результатов при наличии запроса
    // obj: {param: <string - название параметра>, value: <тип зависит от выбранного парамметра>}
    changeQueryParamAndUpdateResults({ state, dispatch, commit }, obj) {
      let modifiedParameter = null;
      let modifiedValue = null;

      switch (obj.param) {
        case 'offset':
          modifiedParameter = 'searchOffset';
          modifiedValue = obj.value;
          break;
        case 'limit':
          modifiedParameter = 'searchItemsLimit';
          modifiedValue = obj.value;
          break;
        case 'availableOnly':
          modifiedParameter = 'searchAvailableOnly';
          modifiedValue = obj.value;
          break;
        case 'types':
          modifiedParameter = 'searchTypes';
          modifiedValue = obj.value.map(i => Object.assign({}, i));
          break;
        case 'organizations':
          modifiedParameter = 'searchOrganizations';
          modifiedValue = obj.value.map(i => Object.assign({}, i));
          break;
        case 'designers':
            modifiedParameter = 'searchDesigners';
            modifiedValue = obj.value.map(i => Object.assign({}, i));
            break;
        case 'statuses':
          modifiedParameter = 'searchStatuses';
          let newStatusesArr = state.searchStatuses.map(i => i);

          if (obj.value.checked) {
            newStatusesArr.push({
              id: obj.value.id,
              name: obj.value.name
            });
          } else {
            newStatusesArr.splice(
              newStatusesArr.findIndex(i => i.id === obj.value.id),
              1
            );
          }
          modifiedValue = newStatusesArr;
          break;
        case 'dates':
            // параметр описания фильтра
            modifiedParameter = 'searchDates';
            let newDatesArr = state.searchDates.map(i => i);

            if (obj.value.value != "") {
              let modValue = obj.value.value.substr(8, 2) + "." + 
                obj.value.value.substr(5, 2) + "." + 
                obj.value.value.substr(0, 4);
              let ind = newDatesArr.findIndex(i => i.id === obj.value.id);
              if (ind === -1)
                newDatesArr.push({
                  id: obj.value.id,
                  name: obj.value.name,
                  value: modValue
                });
              else 
                newDatesArr[ind].value = modValue;
            } else {
              newDatesArr.splice(
                newDatesArr.findIndex(i => i.id === obj.value.id),
                1
              );
            }
            modifiedValue = newDatesArr;
            commit('UPDATE_QUERY_PARAMETER', {
              parameter: modifiedParameter,
              value: modifiedValue
            });

            // параметры запроса
            if (obj.value.id == 0)
              modifiedParameter = 'searchDateModifiedFrom';
            else if (obj.value.id == 1)
              modifiedParameter = 'searchDateModifiedTo';
            else if (obj.value.id == 2)
              modifiedParameter = 'searchDateEnteredFrom';
            else if (obj.value.id == 3)
              modifiedParameter = 'searchDateEnteredTo';
            else if (obj.value.id == 4)
              modifiedParameter = 'searchDateCanceledFrom';
            else if (obj.value.id == 5)
              modifiedParameter = 'searchDateCanceledTo';
            modifiedValue = obj.value.value;
            break;
          case 'datesApprove':
            if (obj.value.id == 1)
              modifiedParameter = 'searchApprovedFrom';
            else if (obj.value.id == 2)
              modifiedParameter = 'searchApprovedTo';
            modifiedValue = obj.value.value;
            break;
          case 'datesAddedInBase':
              // параметр описания фильтра
              modifiedParameter = 'searchAddedFilter';
              modifiedValue = "";
              if (obj.value.bMonth) {
                if (obj.value.monthFrom) {
                  modifiedValue += "с " + obj.value.monthFrom;
                  if (obj.value.monthTo)
                    modifiedValue += " ";
                }
                if (obj.value.monthTo) 
                  modifiedValue += "по " + obj.value.monthTo;
              }
              else {
                if (obj.value.dayFrom) {
                  modifiedValue += "с " + obj.value.dayFrom.substr(8, 2) + "." + 
                    obj.value.dayFrom.substr(5, 2) + "." + 
                    obj.value.dayFrom.substr(0, 4);
                  if (obj.value.dayTo)
                    modifiedValue += " ";
                }
                if (obj.value.dayTo) 
                  modifiedValue += "по " + obj.value.dayTo.substr(8, 2) + "." + 
                    obj.value.dayTo.substr(5, 2) + "." + 
                    obj.value.dayTo.substr(0, 4);
              }
              commit('UPDATE_QUERY_PARAMETER', {
                parameter: modifiedParameter,
                value: modifiedValue
              });
  
              // параметры запроса
              modifiedParameter = 'searchAddedFrom';
              modifiedValue = obj.value.dayFrom;
              commit('UPDATE_QUERY_PARAMETER', {
                parameter: modifiedParameter,
                value: modifiedValue
              });

              modifiedParameter = 'searchAddedTo';
              modifiedValue = obj.value.dayTo;
              commit('UPDATE_QUERY_PARAMETER', {
                parameter: modifiedParameter,
                value: modifiedValue
              });

              modifiedParameter = 'searchAddedFromDay';
              modifiedValue = obj.value.dayFromDay;
              commit('UPDATE_QUERY_PARAMETER', {
                parameter: modifiedParameter,
                value: modifiedValue
              });

              modifiedParameter = 'searchAddedToDay';
              modifiedValue = obj.value.dayToDay;
              commit('UPDATE_QUERY_PARAMETER', {
                parameter: modifiedParameter,
                value: modifiedValue
              });

              modifiedParameter = 'searchAddedIsMonth';
              modifiedValue = obj.value.bMonth;
              commit('UPDATE_QUERY_PARAMETER', {
                parameter: modifiedParameter,
                value: modifiedValue
              });

              modifiedParameter = 'searchAddedMonthFrom';
              modifiedValue = obj.value.monthFrom;
              commit('UPDATE_QUERY_PARAMETER', {
                parameter: modifiedParameter,
                value: modifiedValue
              });

              modifiedParameter = 'searchAddedMonthTo';
              modifiedValue = obj.value.monthTo;
              commit('UPDATE_QUERY_PARAMETER', {
                parameter: modifiedParameter,
                value: modifiedValue
              });
              break;
          default:
            console.error(
              'From changeQueryParamAndUpdateResults. Could not resolve query param: ',
              obj.param
            );
      }
      if (modifiedParameter === null) return;

      commit('UPDATE_QUERY_PARAMETER', {
        parameter: modifiedParameter,
        value: modifiedValue
      });
      if( modifiedParameter !== "searchOffset" ) {
        commit('UPDATE_QUERY_PARAMETER', {
          parameter: 'searchOffset',
          value: 0
        });
      }      

      // Если все фильтры окажутся сюрошенными, то поисковая сессия завершится автоматически
      dispatch('checkAllFiltersAreEmpty');
      if (state.sessionStatus) dispatch('getSearchResults');
    },
    setNewSortOrder({ state, dispatch, commit }, sortArr) {
      commit('UPDATE_QUERY_PARAMETER', {
        parameter: 'searchOffset',
        value: 0
      });
      commit('UPDATE_SORT_ORDER', sortArr.map(i => Object.assign({}, i)));
      dispatch('getSearchResults');
    },
    changeSortingFromTable({ dispatch, commit }, obj) {
      commit('CHECK_AND_CHANGE_SORT_ORDER', obj); 
      dispatch('changeSortParamenter', obj);
    },
    changeSortParamenter({ dispatch, commit }, obj) {
      commit('UPDATE_QUERY_PARAMETER', {
        parameter: 'searchOffset',
        value: 0
      });
      commit('CHANGE_SORT_PARAMETER', obj);
      dispatch('getSearchResults');
    },
    async resetRequest({ dispatch, commit }, skipUpdate) {
      commit('UPDATE_SESSION_STATUS', '');
      commit('RESET_QUERY');
      commit('RESET_FILTERS');

      // For edge situation (share links, fronpage buttons etc.) no data update
      if( !skipUpdate ) await dispatch('getSearchResults');
    },

    async processShareLink({ state, dispatch, commit }, queryObj) {
      await dispatch('resetRequest', true)

      let searchObj = {}
      let promicesArr = []

      SHARE_CONFIG.forEach( item => {
        if( !(item.queryKey in queryObj) ) return

        switch(item.type) {
          case 'number':
          case 'string':
            if(Array.isArray(item.searchKey)) {
              if( !searchObj[item.searchKey[0]] ) {
                searchObj[item.searchKey[0]] = {}
              }
              searchObj[item.searchKey[0]][item.searchKey[1]] = item.type === 'number'
                ? +queryObj[item.queryKey]
                : queryObj[item.queryKey]
            } else {
              searchObj[item.searchKey] = item.type === 'number'
                ? +queryObj[item.queryKey]
                : queryObj[item.queryKey]
            }           
            break;
          case 'sort':
            let arr = []

            queryObj[item.queryKey].split(',').forEach(item => {
              let asc = item.charAt(0) !== '-'

              if( !asc ) item = item.slice(1)
              arr.push({
                asc: asc,
                field: item,
                label: INITIAL_SORTING.filter( i => i.field === item)[0].label,
                active: true
              })
            })
            let activeFields = arr.map(i => i.field)

            INITIAL_SORTING
              .filter(i => activeFields.indexOf(i.field) === -1)
              .forEach(i => {arr.push(i)})
            searchObj[item.searchKey] = arr
            break;
          case 'array':
            let promise = apiDocuments[item.options.apiFunction](item.options.addIds? queryObj[item.queryKey].split(','):'')

            promicesArr.push({
              key: item.searchKey,
              query: queryObj[item.queryKey],
              promise: promise,
              ids: item.options.addIds
            })   
            break;
        }
      })
      for(let i=0; i < promicesArr.length; i++) {
        let res =  await promicesArr[i].promise

        searchObj[promicesArr[i].key] = []
        if( promicesArr[i].ids ) {
          if( 'title' in res[0] ) {
            res.forEach( item => {
              searchObj[promicesArr[i].key].push({
                id: item.id,
                title: item.title
              })
            })
          } else if(promicesArr[i].key === 'searchClassifiers') {  // Костыль
            res.forEach( item => {
              searchObj[promicesArr[i].key].push({
                id: item.id,
                title: item.name
              })
            })
          } else {
            res.forEach( item => {
              searchObj[promicesArr[i].key].push({
                id: item.id,
                name: item.name
              })
            })
          }
        } else {
          // Обработка статусов
          promicesArr[i].query.split(',').forEach( item => {
            searchObj[promicesArr[i].key].push({
              id: item,
              name: res[item]
            })
          })
        }
      }
      commit('UPDATE_SEARCH_REQUEST_FROM_HISTORY', setFullQuery(state, searchObj))
      await dispatch('getSearchResults')
    },



    async resetFilters({ state, dispatch, commit }) {
      commit('RESET_FILTERS');
      dispatch('checkAllFiltersAreEmpty');
      if (state.sessionStatus) {
        await dispatch('getSearchResults');
      } else {
        commit('SET_SEARCH_RESULTS', { items: [], total: 0 });
      }
    },

    async toggleDocumentAsFavorite({ state, dispatch, commit }, obj) {
      // obj:{documentId: <string>, isFavorite: <boolean>}
      if( state.loading ) return;

      commit('SET_IS_LOADING');
      try {
        await apiUser.setDocumentIsFavorite(obj.documentId, obj.isFavorite);
        commit('TOGGLE_ITEM_AS_FAVORITE', obj);

        dispatch('updateCurrentDocumentInfoProperty', {
          name: 'isFavorite',
          value: obj.isFavorite
        });
        commit('CANCEL_LOADING');
      } catch (err) {
        commit('CANCEL_LOADING');
        dispatch('notifications/CREATE_TOAST', {
          text: err.message ? err.message : err
        });
      }
    },

    async toggleDocumentAsWatched({ dispatch, commit }, obj) {
      // obj:{documentId: <string>, isWatched: <boolean>}
      try {
        await apiUser.setDocumentIsWatched(obj.documentId, obj.isWatched);
        commit('TOGGLE_ITEM_AS_WATCHED', obj);

        dispatch('updateCurrentDocumentInfoProperty', {
          name: 'isWatched',
          value: obj.isWatched
        });
      } catch (err) {
        console.error(
          'Error when toggle item as watched: ',
          err.message ? err.message : err
        );
      }
    },

    checkAllFiltersAreEmpty({ state, commit }) {
      let isEmpty = true;

      if (state.searchQuery.text) isEmpty = false;
      if (+state.searchAvailableOnly) isEmpty = false;
      if (state.searchClassifiers.length) isEmpty = false;
      if (state.searchChecklists.length) isEmpty = false;
      if (state.searchStatuses.length) isEmpty = false;
      if (state.searchDates.length) isEmpty = false;
      if (state.searchAddedTo.length) isEmpty = false;
      if (state.searchAddedFrom.length) isEmpty = false;
      if (state.searchAddedToDay.length) isEmpty = false;
      if (state.searchAddedFromDay.length) isEmpty = false;
      if (state.searchTypes.length) isEmpty = false;
      if (state.searchOrganizations.length) isEmpty = false;
      if (state.searchDesigners.length) isEmpty = false;

      if (state.sessionStatus === 'search' && isEmpty) {
        commit('UPDATE_SESSION_STATUS', '');
      }
    },

    setOpenInWindowAction({ commit, state }, boolean) {
      if (boolean != undefined) {
        boolean = boolean == 'true' || boolean == true;
        commit('setOpenInWindow', boolean);
      }
    },

    // ------------- From URL init methods (for future refactor) ---------------
    setInitTextQuery({commit}, obj) {
      // Обнуление страницы при изменении запроса, чтобы не выпасть из области видимости
      commit('UPDATE_QUERY_PARAMETER', {
        parameter: 'searchOffset',
        value: 0
      })
      commit('SET_TEXT_QUERY_PARAMS', obj);
    },
    setInitSortOrder({commit}, arr) {
      commit('UPDATE_QUERY_PARAMETER', {
        parameter: 'searchOffset',
        value: 0
      });
      commit('UPDATE_SORT_ORDER', arr);
    },
    setInitClassifier({commit}, obj){
      commit('UPDATE_CLASSIFIERS_REQUEST', {
        mode: 'add',
        value: {
          id: obj.id,
          title: obj.name
        }
      });
    }
  },

  mutations: {
    SET_MODE_VIEW(state, mode) {
      state.modeView = mode
    },
    SET_CURRENT_DEVICE_SETTINGS(state, config) {
      state.searchTableConfig = config.map(i => i)
    },
    SET_NEW_TABLE_COLUMNS_WIDTH(state, {leftCol, rightCol, deltaWidth, totalWidth}) {
      let currTotal = state.searchTableConfig.reduce((acc, item) => (acc+(item.active?item.colWidth:0)),0)
      let leftWidth = +state.searchTableConfig[leftCol].colWidth + currTotal*deltaWidth/totalWidth
      let rightWidth = +state.searchTableConfig[rightCol].colWidth - currTotal*deltaWidth/totalWidth

      Vue.set(state.searchTableConfig[leftCol], 'colWidth', leftWidth)
      Vue.set(state.searchTableConfig[rightCol], 'colWidth', rightWidth)
    },
    SET_NEW_TABLE_CONFIG_PROP(state, {name, prop, mode}) {
      let ind = state.searchTableConfig.findIndex( i => i.name === name)
    
      Vue.set(state.searchTableConfig[ind], prop, mode)
    },
    SET_NEW_TABLE_COLUMNS_ORDER(state, {newIndex, oldIndex}){
      if( newIndex === oldIndex ) return
      let col = state.searchTableConfig.splice(oldIndex, 1)[0]

      state.searchTableConfig.splice(newIndex, 0, col)
    },
    SET_SEARCH_HISTORY(state, history) {
      state.history = JSON.parse(history);
    },
    UPDATE_SEARCH_HISTORY(state, obj) {
      // obj: { query:<obj>, total: <num>}
      const isSameText = state.history.findIndex(
        i => i.query.text === obj.query.text
      );

      if (isSameText === -1) {
        if (state.history.length > 9) {
          state.history.shift(0);
        }
      } else {
        state.history.splice(isSameText, 1);
      }
      state.history.push(obj);
      localStorage.setItem('searchHistory', JSON.stringify(state.history));
    },
    SET_CLASSIFIERS_LIST(state, list) {
      // Добавление свойства для того, чтобы оно было реактивным
      list.forEach(item => {
        item.folders = undefined;
      });
      state.classifiersList = list;
    },
    SET_CLASSIFIER_FOLDERS(state, obj) {
      state.classifiersList[obj.position].folders = obj.folders;
    },
    SET_TEXT_QUERY_PARAMS(state, obj) {
      state.searchQuery = { ...obj };
    },
    SET_IS_LOADING(state) {
      state.loading = true;
      state.loadingError = null;
    },
    SET_SEARCH_RESULTS(state, results) {
      if (typeof results !== 'object' || !Array.isArray(results.items)) {
        throw new Error('Invalid query results format.');
      }

      state.result.items = results.items;
      state.result.total =
        'total' in results ? parseInt(results.total) || 0 : 0;
    },
    SET_SEARCH_ERROR(state, err) {
      state.loadingError = err;
    },
    SET_SIDEBAR_STATUS(state, mode) {
      state.sidebarStatus = mode;
    },
    UPDATE_SESSION_STATUS(state, mode) {
      state.sessionStatus = mode;
    },
    UPDATE_CLASSIFIERS_REQUEST(state, obj) {
      // obj: {mode: <'clean'|'add'|'remove'>, value(?): <id(string)> }
      switch (obj.mode) {
        case 'add':
          state.searchClassifiers.push(obj.value);
          break;
        case 'remove':
          const ind = state.searchClassifiers.findIndex(
            item => item.id === obj.value.id
          );

          state.searchClassifiers.splice(ind, 1);
          break;
        case 'clean':
          state.searchClassifiers = [];
          break;
        default:
          console.error('Wrong action mode in UPDATE_CLASSIFIERS_REQUEST');
      }
    },
    UPDATE_CHECKLISTS_REQUEST(state, obj) {
      // obj: {mode: <'clean'|'add'|'remove'>, value(?): <id(string)> }
      switch (obj.mode) {
        case 'add':
          state.searchChecklists.push(obj.value);
          break;
        case 'remove':
          const ind = state.searchChecklists.findIndex(
            item => item.id === obj.value.id
          );

          state.searchChecklists.splice(ind, 1);
          break;
        case 'clean':
          state.searchChecklists = [];
          break;
        default:
          console.error('Wrong action mode in UPDATE_CHECKLISTS_REQUEST');
      }
    },
    UPDATE_CHECKLISTS_SEARCH_STRING(state, str) {
      state.checklistsSearchString = str;
    },
    UPDATE_FOUND_CHECKLISTS_DATA(state, arr) {
      state.foundChecklists = arr;
    },
    UPDATE_QUERY_PARAMETER(state, obj) {
      state[obj.parameter] = obj.value;
    },
    UPDATE_SORT_ORDER(state, arr) {
      state.searchSort = arr;
    },
    CHECK_AND_CHANGE_SORT_ORDER(state, obj) {
      let newFieldNum = state.searchSort.findIndex( i => i.field === obj.name )
      let firstActiveNum = state.searchSort.findIndex( i => i.active )

      if(newFieldNum > firstActiveNum) {
        let item = state.searchSort.splice(newFieldNum, 1)[0]

        state.searchSort.splice(firstActiveNum, 0, item)        
      }
    },
    CHANGE_SORT_PARAMETER(state, obj) {
      let num = state.searchSort.findIndex( i => i.field === obj.name )

      Vue.set(state.searchSort[num], obj.parameter, obj.value)
    },
    RESET_FILTERS(state) {
      state.searchAvailableOnly = 0;
      state.searchClassifiers = [];
      state.searchChecklists = [];
      state.searchStatuses = [];
      state.searchDates = [];
      state.searchTypes = [];
      state.searchOrganizations = [];
      state.searchDesigners = [];
      state.searchDateModifiedFrom = "";
      state.searchDateModifiedTo = "";
      state.searchDateEnteredFrom = "";
      state.searchDateEnteredTo = "";
      state.searchDateCanceledFrom ="";
      state.searchDateCanceledTo ="";
      state.searchApprovedFrom = "",
      state.searchApprovedTo = "",
      state.searchAddedIsMonth = "";
      state.searchAddedFrom = "";
      state.searchAddedTo = "";
      state.searchAddedFromDay = "";
      state.searchAddedToDay = "";
      state.searchAddedMonthFrom = "";
      state.searchAddedMonthTo = "";
      state.searchAddedFilter = ""; 
  

      (state.searchItemsLimit = 20), (state.searchOffset = 0);
      state.searchSort = INITIAL_SORTING.map( i => Object.assign({}, i))

      //TODO: Check data in table config to set correct datye type

      // Это не фильтр, но требуется для корректной работы поиска в перечнях
      state.checklistsSearchString = '';
      state.foundChecklists = [];
    },
    RESET_QUERY(state) {
      state.searchQuery.text = '';
    },
    UPDATE_SEARCH_REQUEST_FROM_HISTORY(state, obj) {
      // Хак для добавления нового поля в сортировке
      if( obj.sort && obj.sort.length === 4 ){
        obj.sort.push({
          field: 'startDate',
          label: 'Дата вступления в силу',
          asc: false,
          active: false          
        })
      }

      state.searchQuery.text = obj.text;
      state.searchQuery.searchBy = obj.searchBy;
      state.searchAvailableOnly = obj.availableOnly;
      state.searchCountTotal = obj.countTotal;
      state.searchItemsLimit = obj.limit;
      state.searchOffset = obj.offset;

      state.searchTypes = obj.types.map(i => Object.assign({}, i));
      state.searchClassifiers = obj.classifiers.map(i => Object.assign({}, i));
      state.searchChecklists = obj.checklists.map(i => Object.assign({}, i));
      state.searchOrganizations = obj.organizations.map(i => Object.assign({}, i));
      state.searchDesigners = obj.designers.map(i => Object.assign({}, i));
      state.searchStatuses = obj.statuses.map(i => Object.assign({}, i));
      state.searchDates = obj.dates.map(i => Object.assign({}, i));
      state.searchSort = obj.sort.map(i => Object.assign({}, i));
    },
    TOGGLE_ITEM_AS_FAVORITE(state, { documentId, isFavorite }) {
      state.result.items.forEach(item => {
        if (item.id === documentId) {
          item.isFavorite = isFavorite;
        }
      });
    },
    TOGGLE_ITEM_AS_WATCHED(state, { documentId, isWatched }) {
      state.result.items.forEach(item => {
        if (item.id === documentId) {
          item.isWatched = isWatched;
        }
      });
    },
    CANCEL_LOADING(state) {
      state.loading = false;
    },

    setOpenInWindow(state, value) {
      localStorage.setItem('openInWindow', value);
      state.openInWindow = value;
    }
  }
};
